import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Field } from 'redux-form'
import { FieldError } from 'components/misc'

export default class RadioError extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired
  }

  renderField = field => {
    const { meta } = field

    return <FieldError toShow={(meta.touched && meta.error)} message={meta.error} />
  }

  render() {
    return <Field name={this.props.name} component={field => this.renderField(field)} />
  }
}
